import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <h1 className="text-4xl font-heading font-bold mb-6">Terms of Use</h1>
          <p className="text-sm text-muted-foreground mb-8">Last updated: {new Date().toLocaleDateString('en-GB', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}</p>
          
          <div className="prose prose-gray max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                By accessing and using Flexaura's platform, you accept and agree to be bound by 
                the terms and provision of this agreement. Flexaura operates as a marketplace 
                connecting customers with licensed financial partners for payment solutions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">2. Flexaura's Role as Marketplace</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Flexaura is a financial marketplace platform that connects users with various 
                payment options including Buy Now Pay Later (BNPL) services, bank installment 
                plans, and extended financing solutions.
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <p className="text-blue-800 font-medium">Critical Disclaimer:</p>
                <ul className="list-disc list-inside text-blue-700 space-y-1 mt-2">
                  <li><strong>Flexaura does not provide credit, loans, or financing directly</strong></li>
                  <li><strong>Flexaura assumes no credit risk whatsoever</strong></li>
                  <li>All credit services are provided by our licensed financial partners</li>
                  <li>Eligibility, terms, and approval decisions are made solely by financial partners</li>
                  <li>Payment obligations are between you and the financial partner, not Flexaura</li>
                </ul>
              </div>
              <p className="text-muted-foreground leading-relaxed">
                By using our platform, you acknowledge that Flexaura serves only as an intermediary 
                to connect you with appropriate financing options and bears no liability for credit decisions, 
                payment processing, or default situations.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">3. User Responsibilities</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2">
                <li>Provide accurate and truthful information</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Use the platform only for lawful purposes</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Accept full responsibility for payment obligations with financial partners</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">4. Financial Partner Relationships</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                When you select a payment option through our platform, you enter into a separate 
                agreement directly with the relevant financial partner. This is a critical distinction:
              </p>
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                <p className="text-red-800 font-medium">Important: No Flexaura Liability</p>
                <ul className="list-disc list-inside text-red-700 space-y-1 mt-2">
                  <li>Flexaura is not a party to your financing agreement</li>
                  <li>Flexaura is not responsible for credit terms, interest rates, or payment schedules</li>
                  <li>Flexaura is not liable for any defaults, late payments, or credit issues</li>
                  <li>All payment disputes must be resolved directly with the financial partner</li>
                  <li>Customer defaults are the sole responsibility of the customer and financial partner</li>
                </ul>
              </div>
              <p className="text-muted-foreground leading-relaxed">
                Flexaura's role is limited to facilitating the initial connection and sharing necessary 
                information for eligibility assessment and checkout processing only. We do not participate 
                in ongoing payment relationships or bear any credit-related risks.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">5. Disclaimer of Warranties</h2>
              <p className="text-muted-foreground leading-relaxed">
                Flexaura provides the platform "as is" without any warranties, express or implied. 
                We do not guarantee the availability, accuracy, or reliability of the platform 
                or the services provided by our financial partners.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">6. Limitation of Liability</h2>
              <p className="text-muted-foreground leading-relaxed">
                Flexaura shall not be liable for any direct, indirect, incidental, special, 
                or consequential damages resulting from the use or inability to use the platform 
                or services provided by financial partners.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">7. Privacy</h2>
              <p className="text-muted-foreground leading-relaxed">
                Your privacy is important to us. Please review our Privacy Policy, which also 
                governs your use of the platform, to understand our practices.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">8. Modifications</h2>
              <p className="text-muted-foreground leading-relaxed">
                Flexaura reserves the right to modify these terms at any time. Changes will be 
                effective immediately upon posting to the platform. Your continued use of the 
                platform constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold mb-4">9. Contact Information</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have any questions about these Terms of Use or need support, please contact us:
              </p>
              <div className="bg-flexaura-gray/50 rounded-lg p-4 mt-4">
                <p className="font-semibold">Flexaura Marketplace</p>
                <p className="text-muted-foreground">Email: hector@flexaura.me</p>
                <p className="text-sm text-muted-foreground mt-2">
                  For the fastest response, please include "Terms of Use" in your subject line.
                </p>
              </div>
              <p className="text-sm text-muted-foreground mt-4">
                <strong>Note:</strong> For issues related to financing, payments, or credit decisions, 
                please contact your financial partner directly as Flexaura cannot assist with 
                credit-related matters.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;